import React, { useContext, useEffect, useState } from 'react'
import reminderIcon from "../assets/icons/NotificationsIcons/reminder 1.png"
import sendIcon from "../assets/icons/NotificationsIcons/send (3) 1.png"
import { getData } from '../axios/axiosHelper';
import toast from 'react-hot-toast';

const NotificationsCenterHooks = () => {
  const [showImage, setShowImage] = useState(false);
  const [image, setImage] = useState(false)
  const handleCloseImage = () => setShowImage(false);
  const handleShowImage = () => setShowImage(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [laoding, setLaoding] = useState(false);
  const [allNotifications, setAllNotifications] = useState([])
  const NavItems = [
    { name: "Notifications", to: "/notificationscenter", icon: reminderIcon },
    { name: "Send Notifications", to: "/sendnotifications", icon: sendIcon },
  ];


  const getAllNotifications = (page = 1, perPage = 5) => {
    setLaoding(true);
    getData(`/notifications/users?page=${page}&perPage=${perPage}`, true)
      .then((response) => {
        setAllNotifications(response?.data?.data);
        setTotalPages(response?.data?.pagination?.totalPages || 1);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setLaoding(false);
      });
  };

  useEffect(() => {
    getAllNotifications(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage]);

  const getPageNumbers = () => { 
    const pages = [];
    const startPage = Math.max(1, currentPage - 1);
    const endPage = Math.min(totalPages, startPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const clicklImage = (image) => {
    setImage(image)
    handleShowImage()
  }


  return {
    NavItems,
    laoding,
    allNotifications,
    handlePageChange,
    getPageNumbers,
    totalPages,
    currentPage,
    itemsPerPage,
    showImage,
    handleCloseImage,
    clicklImage,
    image
  }
}

export default NotificationsCenterHooks